import React, {useEffect, useState} from "react";
import {useAuth} from "../auth/use-auth";

const Signin = () => {
    const auth = useAuth();
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    useEffect(() => {
        auth.refreshToken();
    }, []);

    const signin = (event) => {
        event.preventDefault();
        auth.signin(login, password);
        if (auth.remember) {
            localStorage.setItem("rememberUser", true);
        }
    };
    const handleCheck = (event) => {
        if (event.target.checked) {
            auth.setRemember(true);
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
            <form
                className="row g-3 w-25 border p-3 rounded-3"
                style={{marginBottom: 100}}
                onSubmit={signin}
            >
                <div className="mb-1">
                    <label className="form-label">Логин</label>
                    <input
                        type="email"
                        className="form-control"
                        value={login}
                        required
                        onChange={(event) => setLogin(event.target.value)}
                        onKeyPress={(event) => event.key === "Enter" && signin}
                    />
                </div>
                <div className="mb-3">
                    <label className="col-sm-2 col-form-label">Пароль</label>
                    <input
                        type="password"
                        required
                        className="form-control"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        onKeyPress={(event) => event.key === "Enter" && signin}
                    />
                </div>
                {auth.signinError.length !== 0 && (
                    <div className="mb-3">
                        <p className="font-weight-bold text-danger">{auth.signinError}</p>
                    </div>
                )}
                <div className="mb-3 d-flex justify-content-sm-between align-items-md-center">
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={handleCheck}
                            id="rememberMeCheck"
                            name="rememberMeCheck"
                        />
                        <label className="form-check-label" htmlFor="rememberMeCheck">
                            Запомнить меня
                        </label>
                    </div>
                    <div>
                        <button type="submit" className="btn btn-primary">
                            Войти
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default Signin;
